
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calling-your-doctor",
      function () {
        return require("private-next-pages/calling-your-doctor.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calling-your-doctor"])
      });
    }
  